var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-info"},[_vm._m(0),_c('span',{class:{ truncate: _vm.shortVersion },domProps:{"innerHTML":_vm._s(
      _vm.$t('views.single.candidate.birthyear', {
        year: _vm.candidate.birthYear || '-',
        age: !_vm.isNullOrWhitespace(_vm.candidate.birthYear)
          ? new Date().getFullYear() - parseInt(_vm.candidate.birthYear)
          : '-'
      })
    )}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-info-icon"},[_c('img',{attrs:{"src":require("@/assets/icons/genicon-icons8-birthday.svg"),"alt":"birthday"}})])
}]

export { render, staticRenderFns }